import biLogger from './biLogger.config';
import biLoggerMiddleware from './biLogger.middleware';

export default biLogger;
export {
  biLoggerMiddleware
};



// WEBPACK FOOTER //
// ./chat-app/biLogger/index.js